import React from 'react';
import axios from 'axios';

export default function LoginPage() {
  async function handleLogin(e) {
    e.preventDefault();
    const username = e.target.username.value; // заменили email на username
    const password = e.target.password.value;

    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/login`, {
        username,
        password,
      });

      localStorage.setItem('token', res.data.token);
      window.location.href = '/';
    } catch (e) {
      alert('Login failed');
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background text-white">
      <form onSubmit={handleLogin} className="bg-zinc-900 rounded p-6 w-full max-w-sm space-y-3">
        <div className="text-xl font-semibold mb-2">Вход в систему</div>

        {/* Поле имени пользователя вместо email */}
        <input
          name="username"
          type="text"
          placeholder="Имя пользователя"
          className="w-full bg-zinc-800 rounded px-3 py-2"
          required
        />

        <input
          name="password"
          type="password"
          placeholder="Пароль"
          className="w-full bg-zinc-800 rounded px-3 py-2"
          required
        />

        <button className="w-full bg-emerald-600 hover:bg-emerald-700 px-3 py-2 rounded">
          Войти
        </button>

        <div className="text-center text-sm text-zinc-400 mt-2">
          Есть вопросы? Напишите мне в{' '}
          <a
            href="https://t.me/VorisxonS"
            target="_blank"
            rel="noopener noreferrer"
            className="text-emerald-400 hover:underline"
          >
            Telegram
          </a>
          .
        </div>
      </form>
    </div>
  );
}
